<template>
    <div class="forgot-password" 
        :class="{
            sectionConfirmOtp: step === 2,
            sectionSetPassword: step === 3,
        }">
        <template v-if="step === 1">
            <ButtonCustom
                type="go-back"
                classBtn="forgot-password__header"
                text="Forgot Password"
                :isGoBackHistory="false"
                @onClickButton="$router.push('/login')"
            />

            <div class="forgot-password__body">
                <div class="form-custom">
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="method-forgot-password"
                            v-model="methodForgotPassword"
                            :options="methodOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-options"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>

                <FormCommon
                    :formItem="methodForgotPassword === '2' ? formItemEmail : formItemPhone"
                    :dataForm="dataForm"
                    @update-form-data="updateFormData"
                    @onSubmitForm="onClickForgotPassword"
                >
                    <b-input-group-prepend
                                slot="propend-phone-number"
                                class="phone-code"
                            >
                                <button
                                    class="show-dropdown"
                                    type="button"
                                    @click="showDropDow"
                                >
                                    <img
                                        class="user-avatar"
                                        :src="
                                            require(`@/assets/images/flags/${dataForm.flag}`)
                                        "
                                        :alt="dataForm.flag"
                                    />
                                    <span class="name-country">{{
                                        dataForm.nameCountry
                                    }}</span>
                                    ({{ dataForm.calling_code }})
                                </button>

                                <b-dropdown ref="select_phone_code">
                                    <b-form-input
                                        v-model="textSearchPhoneNumber"
                                        :placeholder="
                                            getTranslatedText('Search')
                                        "
                                        @input="onChangeFilterPhoneNumbers"
                                    ></b-form-input>
                                    <b-dropdown-item
                                        @click="selectPhoneCode(item)"
                                        v-for="(item, index) in phoneNumbersFilter"
                                        :key="index"
                                    >
                                        <div>
                                            <img
                                                class="user-avatar"
                                                :src="
                                                    require(`@/assets/images/flags/${item.flag}`)
                                                "
                                                :alt="item.flag"
                                            />
                                            <span class="name-country">{{
                                                item.name
                                            }}</span>
                                            ({{ item.number }})
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-input-group-prepend>
                    <div slot="button">
                        <div class="forgot-password__box-btn">
                            <ButtonCustom
                                :isLoading="isLoadingButton"
                                text="send"
                                classBtn="forgot-password__box-btn-send"
                                typeBtn="submit"
                                type="primary"
                                icon="arrow-right.png"
                            />
                        </div>
                    </div>
                </FormCommon>
            </div>
        </template>
        <div v-else-if="step === 2" class="section-confirm-otp">
                <ConfirmOTP
                    :dataSource="dataForm"
                    @onClickGoBack="onClickGoBack"
                    @onSubmitForm="onSubmitResetPassword"
                    @sendOTP="onClickForgotPassword('resend')"
                    :methodsChangeInfo="methodForgotPassword === '2' ? 'email' : 'phone'"
                    :text="getTranslatedText('enter otp')"
                    :textBtnContinue="getTranslatedText('reset password')"
                />
        </div>
        <div v-else class="section-confirm-otp">
            <SetPassWord
                :text="getTranslatedText('reset password')"
                :textBtnContinue="getTranslatedText('done')"
                @on-submit-password="resetPassWord"
                @onResetPassword="onSubmitResetPassword"
                @submitResend="onClickForgotPassword('resend')"
                @onClickGoBack="onClickGoBack"
                @submitDone="$router.push('/home')"
                :dataUser="dataForm"
                :methodLogin="parseInt(methodForgotPassword)"
                :isShowIconBtnContibue="false"
            />
        </div>
        <Toast :title="toastData.message" :type="toastData.type" />
</div>
</template>
<script>
import { phoneNumbers } from "@/resources/phoneNumber";
import AuthService from "@/services/auth.service";
import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import Toast from "@/components/common/toast/Toast.vue";

import ConfirmOTP from "@/views/mobile/authenticate/ConfirmOTP";
import SetPassWord from "@/views/mobile/authenticate/SetPassword.vue";

import languageMixin from "@/mixins/language/language-mixin";

import { filterFullTextSearch, isStrEmpty } from "@/components/common/utils";

export default {
    mixins: [languageMixin],
    components: {
        FormCommon,
        ButtonCustom,
        ConfirmOTP,
        SetPassWord,
        Toast
    },
    mounted() {
        const parameters = this.$route.query;
        if (parameters.step) {
            this.step = +parameters.step;
            this.methodForgotPassword = !isStrEmpty(localStorage.getItem('methodForgotPassword')) ? parseInt(localStorage.getItem('methodForgotPassword')) : 1
            this.codeOTP = parameters.code || '';
            this.$router.replace({'query': null});
        } else {
            this.step = 1;
        }
    },
    data() {
        return {
            methodForgotPassword: '2',
            step: 1,
            isLoadingButton: false,
            textSearchPhoneNumber: '',
            toastData: {
                message: "",
                type: "success",
            },
            methodOptions: [
                { text: this.getTranslatedText('Email'), value: '2' },
                { text: this.getTranslatedText('By Phone'), value: '1' },
            ],
            phoneNumbersFilter: phoneNumbers,
            phoneNumbers,
            dataForm: {
                phone: "",
                email: "",
                calling_code: "+968",
                code: "+968",
                flag: "Flag_of_Oman.svg",
                nameCountry: "Oman",
            },
            formItemPhone: [
                {
                    type: "input-group",
                    typeInput: "number",
                    placeholder: "",
                    name: "phone",
                    label: "phone Number",
                    for: "input-phone",
                    id: "input-phone-login",
                    prepend: "code",
                    nameSlotInputPrepend: "propend-phone-number",
                    state: null,
                    textInvalid: "Please enter phone",
                    textValid: ""
                },
            ],
            formItemEmail: [
                {
                    type: "input",
                    typeInput: "email",
                    label: "email",
                    placeholder: "email",
                    name: "email",
                    required: true,
                    hideIconRq: true,
                    showIconRequired: true,
                    for: "input-email",
                    id: "input-email",
                    state: null,
                    textInvalid: "Please enter email",
                },
            ],
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                }
                if (value === 0) {
                    this.isDisableResend = false;
                }
            },
            immediate: true,
        },
    },
    methods: {
        onSubmitForm() {
            this.$emit("onSubmitForm", this.dataForm);
        },

        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },

        updateFormData(item) {
            let { value, name } = item;
            this.dataForm[name] = value;
        },

         async onBurInputFormData(event, phoneCode) {
            const { name, value } = event.target;
            let { calling_code, phone } = this.dataForm;

            switch (true) {
                // check phone already exist and change code phone
                case (name === "phone" && value !== phone) ||
                    !isStrEmpty(phoneCode):
                    // calling_code check change code phone

                    calling_code = !isStrEmpty(phoneCode)
                        ? phoneCode.replaceAll("\\+", "")
                        : calling_code.replaceAll("\\+", "");

                    try {
                        const res = await AuthService.checkPhone(
                            calling_code,
                            value
                        );
                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItemPhone[0].state = true;
                            this.formItemPhone[0].textValid = message;
                        } else {
                            this.formItemPhone[0].state = null;
                        }

                        this.dataForm.phone = value;
                    } catch (error) {
                        this.formItemPhone[0].state = false;
                        this.formItemPhone[0].textInvalid = error;
                    }
                    break;
                default:
                    break;
            }
        },

        onClickForgotPassword(type) {
            this.isLoadingButton = true
            let methodForgotPassword = parseInt(this.methodForgotPassword)

            if(methodForgotPassword === 1 &&  this.dataForm.phone.length < 5) {
                this.showToast(
                    this.getTranslatedText('Incorrect phone number'),
                    "error"
                );
                this.isLoadingButton = false
                return false
            }

             if(methodForgotPassword === 2 &&  this.dataForm.email.length < 5) {
                this.showToast(
                    this.getTranslatedText('Incorrect email'),
                    "error"
                );
                this.isLoadingButton = false
                return false
            }

            if (methodForgotPassword === 1 && this.dataForm.phone !== "") {
                AuthService.sendOTPToPhone(
                    "forgot_password",
                    this.dataForm.phone,
                    this.dataForm.calling_code.replaceAll("\\+", "")
                ).then((res) => {
                    if (res.status === 200) {
                        if (type === "resend") {
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "success"
                            );
                        }
                        localStorage.setItem('methodForgotPassword', methodForgotPassword)
                        this.step = methodForgotPassword === 1 ? 2 : 3;
                        this.isLoadingButton = false
                    } else {
                        this.isLoadingButton = false
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            } else {
                AuthService.forgotPasswordByEmail(this.dataForm.email).then(
                    (res) => {
                        if (res.status === 200) {
                            if (type === "resend") {
                                this.showToast(
                                    this.getTranslatedText(res.message),
                                    "success"
                                );
                            }
                            this.step = methodForgotPassword === 1 ? 2 : 3;
                            this.isLoadingButton = false
                        } else {
                            this.isLoadingButton = false
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "error"
                            );
                        }
                    }
                );
            }
        },

        selectPhoneCode(item) {
            if (
                this.dataForm.calling_code !== item.number &&
                !isStrEmpty(this.dataForm.phone)
            ) {
                let event = {
                    target: {
                        value: this.dataForm.phone,
                        name: "phone",
                    },
                };

                let phoneCode = item.number;

                this.onBurInputFormData(event, phoneCode);
            }
            this.dataForm.calling_code = item.number;
            this.dataForm.code = item.number;
            this.dataForm.flag = item.flag;
            this.dataForm.nameCountry = item.name.replace(
                /^(.{5}[^\s]*).*/,
                "$1"
            );
            this.textSearchPhoneNumber = "";
            this.phoneNumbersFilter = phoneNumbers;
        },

        showDropDow() {
            const dropdown = this.$refs.select_phone_code;
            dropdown.show();
        },

        onChangeFilterPhoneNumbers(value) {
            let phoneNumber = [...phoneNumbers];
            if (!isStrEmpty(value)) {
                this.phoneNumbersFilter = filterFullTextSearch(
                    phoneNumber,
                    value,
                    "name",
                    "number"
                );
            } else {
                this.phoneNumbersFilter = phoneNumber;
            }
        },

        onClickGoBack() {
            if (this.methodLogin === 1 && this.step !== 3) {
                this.step -= 1;
            } else {
                this.step = 1;
            }
        },

        onSubmitResetPassword(data) {
            let methodForgotPassword = parseInt(this.methodForgotPassword)
            this.codeOTP = data.code;
            if (methodForgotPassword === 1) {
                AuthService.apiCheckOTPByPhone(
                    data.code,
                    "forgot_password",
                    this.dataForm.phone,
                    this.dataForm.calling_code.replaceAll("\\+", "")
                ).then((res) => {
                    if (res.status === 200) {
                        this.step = 3;
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            } else {
                AuthService.forgotPasswordByEmail(this.dataForm.email).then(
                    (res) => {
                        if (res.status === 200) {
                            this.step = 3;
                        } else {
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "error"
                            );
                        }
                    }
                );
            }
        },

        resetPassWord(data) {
            AuthService.resetPassWord(
                data.password,
                this.codeOTP
            ).then((res) => {
                if (res.status === 200) {
                    this.showToast(
                        this.getTranslatedText(res.message),
                        "success"
                    );
                    setTimeout(() => {
                        this.$router.push('/login')
                        this.step = 1;
                    }, 1000);
                    
                } else {
                    this.showToast(
                        this.getTranslatedText(res.message),
                        "error"
                    );
                }
            });
        },
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/authenticate/_forgot-password.scss"
/>
